module.exports = __webpack_public_path__ + "static/media/Slice8@2x.eb23bf92.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice8@2x.png
// module id = 1437
// module chunks = 0